import { useState, useEffect } from "react";
import apiAxios from "../utils/apiAxios";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { appendAlert } from "../redux/alertSlice";

const useHolidays = () => {
  const [holidays, setHolidays] = useState<string[]>([]);
  const dispatch: AppDispatch = useDispatch();
  const isLogged = useSelector((state: RootState) => state.user.isLogged);

  useEffect(() => {
    const fetchHolidays = async () => {
      if (!isLogged) return; // ログインしていない場合は何もしない

      try {
        const response = await apiAxios.get(`/holidays`);
        const data = response.data;
        setHolidays(data.map((holiday: { date: string }) => holiday.date));
      } catch (error: any) {
        dispatch(
          appendAlert({
            severity: "error",
            message: "データの取得に失敗しました。" + error.message,
            displayTime: 5000,
          })
        );
        console.error("Failed to fetch:", error);
      }
    };
    fetchHolidays();
  }, [isLogged, dispatch]);

  return holidays;
};

export default useHolidays;
